import "../css/CourseDetails.css";
import fs from "../images/full stack.jpg";
import da from "../images/DATA-ANALYTICS.jpg";
import jd from "../images/Java.jpg";
import py from '../images/python.jpg'
import ds from "../images/data-sci.webp"
import dev from "../images/Devops.png"
import sf from "../images/Salesforce.png"
import sap from "../images/sap.jpg"

const courses = [
  {
    id: "Full Stack Development",
    title: "Full Stack Development",
    image: fs,
    overview:
      "Learn how to build complete web applications from front end to back end using modern technologies. This course covers HTML, CSS, JavaScript, React, Node.js, Express.js, and MongoDB, helping you create responsive websites, develop APIs, manage databases, and deploy real-world applications. Through hands-on projects, you'll gain practical experience and build a portfolio that showcases your full-stack development skills.",

    syllabus: [
      {
        title: "Module 1: Frontend Development",
        topics: [
          "HTML",
          "CSS",
          "Javascript",
          "JQuery",
          "React JS",
          "React Bootstrap",
        ],
      },
      {
        title: "Module 2: HTML5",
        topics: [
          "HTML Basics",
          "HTML Elements",
          "HTML Images",
          "HTML Links",
          "HTML Lists",
          "HTML Attributes",
          "HTML Headings",
          "HTML Paragraphs",
          "HTML Styles",
          "HTML Formatting",
          "HTML Comments",
          "HTML Blocks",
          "HTML Classes",
          "HTML ID",
        ],
      },
      {
        title: "Module 3: CSS3",
        topics: [
          "Introduction to CSS",
          "CSS Syntax and Selectors",
          "CSS Colors",
          "CSS Backgrounds",
          "CSS Borders",
          "Position",
          "Setting height and width",
          "Background Color",
          "Background Image",
          "CSS Border",
          "Font Style",
          "Font Color",
          "Margin And Padding",
          "Text Alignment",
        ],
      },
      {
        title: "Module 4: JavaScript",
        topics: [
          "Introduction to JavaScript",
          "Basics of JavaScript",
          "JS Comment",
          "JS Variable",
          "JS Global Variable",
          "JS Data Types",
          "JS Operators",
          "JS If Statement",
          "JS Switch",
          "JS slider",
          "JS Loop",
          "JavaScript DOM",
          "JS Events",
          "onclick",
          "onmouseover",
          "onmouseout",
          "onkeydown",
          "JS validation",
          "JS window.print()",
        ],
      },
      {
        title: "Module 5: JQuery",
        topics: [
          "Introduction to jQuery",
          "Adding jQuery Library to Pages",
          "JQuery Examples",
          "JQuery Selectors",
          "JQuery Element",
          "JQuery Hide and Show",
          "JQuery Fade",
          "JQuery Slide",
          "JQuery Animate",
          "JQuery Stop",
          "JQuery Callback",
          "JQuery Chaining",
          "JQuery Events",
          "JQuery Effects",
          "JQuery Get/Post",
          "JQuery Callback Functions",
          "Setting Element Width & Height",
          "JQuery CSS Methods",
        ],
      },
      {
        title: "Module 6: React JS",
        topics: [
          "Introduction to ReactJS",
          "Basics of ReactJS",
          "Create React Template",
          "Props and State",
          "React Styling",
          "React Events",
          "React Conditionals",
          "React Forms",
          "Reacts Router",
          "ReactJS Maps",
          "Reactjs Tables",
          "ReactJS Material UI",
          "React Hooks",
          "Handling API's",
          "Error Handling",
          "Debugging",
          "Build and Deploy",
          "Firebase with Github App",
          "Designing Shopping Cart API",
          "Firebase with Github App",
          "Firebase Real-time Database",
          "Redux App",
          "Big Project on ReactJS",
          "Deployment via Vercel/Netlify",
        ],
      },
      {
        title: "Module 7: React BootStrap",
        topics: [
          "What is Bootstrap?",
          "How to Install Bootstrap?",
          "Media Query",
          "Bootstrap Grid System",
          "Bootstrap Components",
          "BS Navbar",
          "BS Carousel",
          "BS Forms",
          "BS Popover",
          "BS Grid System",
          "BS Tables",
          "BS Progress Bar",
          "BS Modal",
          "BS Responsive Page",
        ],
      },
      {
        title: "Module 8: Angular JS",
        topics: [
          "What is Angular JS?",
          "Modules and Components",
          "Data Binding in Angular JS",
          "Directives in Angular JS",
          "Dependency Injection",
          "Routing of Angular JS",
          "Forms",
          "Reactive Forms",
          "Pipes",
          "HTTP Requests",
          "Authentication",
          "Angular Modules",
          "HTTP Clients",
          "Animations",
          "Unit Testing",
          "CRUD Operation in Angular",
          "Create an Angular CLI Project",
          "Build CLI Project",
          "Integrate build output with MVC Application",
        ],
      },
      {
        title: "Module 9: React Native",
        topics: [
          "Introduction about React Native",
          "Environmntal Setup",
          "First Application",
          "State of React native",
          "Props",
          "Stlying",
          "Flexbox",
          "Listview",
          "Text Inputs",
          "Scrollview",
          "Images",
          "HTTP",
          "Buttons",
          "Animations",
          "Debugging",
          "Router",
          "Running IOS",
          "Running Android",
        ],
      },
      {
        title: "Module 10: Database Development (with NoSQL)",
        topics: [
          "Introduction to MongoDB",
          "Differnce between MongoDB and SQL",
          "MongoDB Compass",
          "MongoDB Installation",
          "MongoDB Shell",
          "CRUD Operation",
          "Datatypes in MongoDB",
          "Documents in MongoDB",
          "MongoDB Operators",
          "Aggregates in MongoDB Query",
          "MongoDB Atlas",
          "Mongo Projects",
        ],
      },
      {
        title: "Module 11: Database Development (with MySQL)",
        topics: [
          "Introduction to SQL",
          "Data Types in SQL",
          "Operators of SQL",
          "Database",
          "Table",
          "Query",
          "Views",
          "Clauses",
          "Joins",
          "SQL Keys",
          "SQL Indexes",
          "Advanced SQL",
          "Projects",
        ],
      },
      {
        title: "Module 12: Backend Development with NodeJS",
        topics: [
          "Introduction",
          "Environment Setup",
          "First Application",
          "Callback Concepts",
          "Upload Files",
          "Send an Email",
          "Events and Event Emitter",
          "Debugger",
          "Global Objects",
          "Console",
          "Process",
          "Scalling Application",
          "Packaging",
          "RESTFul API",
          "File System",
          "Modules in NodeJS",
          "Built in Modules",
          "Utility Modules",
          "Web Modules",
          "NodeJS MySQL",
          "MySQL with NodeJS",
          "NodeJS  MongoDB",
          "NodeJS with  MongoDB",
          "Create Database",
          "Create Table/Collection",
          "Insert Data/Method",
          "Select Method",
          "Order Method",
          "Where Method",
          "Find Method",
          "Sort Method",
          "Delete Method",
          "Update Method",
          "Limit Method",
          "Join Method",
        ],
      },
      {
        title: "Module 13: Backend Development with ExpressJS",
        topics: [
          "Introduction to ExpressJS",
          "Environment and Installation",
          "Basic Application in ExpressJS",
          "Routing",
          "HTTP Methods",
          "URL Binding",
          "Middleware",
          "Express Functions",
          "Application Functions",
          "Request Function",
          "Response Functions",
          "Router Functions",
          "CRUD Oprerations",
          "Form Data",
          "Database",
          "Express Cookies",
          "Express Session",
          "Authentication",
          "RESTFul APIs",
          "File Uploads",
          "Slowing Down Response",
          "Error Handling",
          "Debugging",
        ],
      },
      {
        title: "Module 11: Project Planning",
        topics: [
          "Static Website",
          "Desktop Application",
          "E-Commerce Websites",
        ],
      },
      {
        title: "Module 12: Cloud Platform",
        topics: ["Git & GitHub", "AWS (Amazon Web Services)"],
      },
      {
        title: "Module 13: GIT",
        topics: [
          "Introduction about GIT",
          "Basic Concepts",
          "Command line",
          "Installation",
          "First Time Setup",
          "Basic Commands",
          "Getting Help",
          "Cheatsheet",
          "Terminology",
          "Life Cycle",
          "Get a Repository",
          "Adding New Files",
          "Viewing Commit History",
          "Git Branching",
          "Git Operations",
          "Git Undoing",
          "Git on the Server",
          "Distributed Git",
          "Customizing Git",
        ],
      },
      {
        title: "Module 14: AWS",
        topics: [
          "Introduction to AWS",
          "Cloud Computing",
          "Management Console",
          "Console Mobile App",
          "Account",
          "Amazon Computer Services",
          "Amazon Network Services",
          "Amazon Storage Sevices",
          "Amazon Database Sevices",
          "Amazon Analytics Sevices",
          "Amazon Application Sevices",
        ],
      },
    ],
  },

  {
    id: "Data Analytics",
    title: "Data Analytics",
    image: da,
    overview:
      "Learn how to collect, analyze, and visualize data to uncover insights and support business decision-making. This course covers data analysis fundamentals, Excel, SQL, Python, data visualization tools, and real-world analytics techniques, helping you transform raw data into meaningful information.",

    syllabus: [
      {
        title: "Module 1: Introduction to Data Analytics",
        topics: [
          "What is Data Analytics?",
          "Types of Data Analytics",
          "Data-Driven Decision Making",
          "Analytics Lifecycle",
        ],
      },
      {
        title: "Module 2: Python",
        topics: [
          "Introduction to Python",
          "Input/Output",
          "Python Operators",
          "Python Data Type",
          "Python Control Panel",
          "Python String",
          "Lists in Python",
          "Python Tuples",
          "Dictionary in Python",
          "Set in Python",
          "Function",
          "File Handling",
          "matplotlib",
          "Projects",
        ],
      },
      {
        title: "Module 3: Database Development (with NoSQL)",
        topics: [
          "Introduction to MongoDB",
          "Differnce between MongoDB and SQL",
          "MongoDB Compass",
          "MongoDB Installation",
          "MongoDB Shell",
          "CRUD Operation",
          "Datatypes in MongoDB",
          "Documents in MongoDB",
          "MongoDB Operators",
          "Aggregates in MongoDB Query",
          "MongoDB Atlas",
          "Mongo Projects",
        ],
      },
      {
        title: "Module 4: Database Development (with MySQL)",
        topics: [
          "Introduction to SQL",
          "Data Types in SQL",
          "Operators of SQL",
          "Database",
          "Table",
          "Query",
          "Views",
          "Clauses",
          "Joins",
          "SQL Keys",
          "SQL Indexes",
          "Advanced SQL",
          "Projects",
        ],
      },
      {
        title: "Module 5: Advanced Excel",
        topics: [
          "Excel",
          "Formatting Cells",
          "Formatting Worksheets",
          "Basic Formula",
          "Excel Formatting",
          "Advanced Options",
        ],
      },
      {
        title: "Module 6: Power BI",
        topics: [
          "Power BI",
          "Power BI Desktop",
          "Power BI Services",
          "Power BI Desktop Services",
          "Power Query Editor",
          "Data Modelling Concept",
          "Power BI - Report Visualizations",
          "Power BI Map Visualizations",
          "Power BI Miscellaneous",
          "Power BI Dashboard",
          "Power BI Sales Production Dashboard",
        ],
      },
      {
        title: "Module 7: Project Planning",
        topics: [
          "Real-World Dataset Analysis",
          "Insight Generation",
          "Dashboard Development",
          "Project Presentation",
        ],
      },
    ],
  },

  {
    id: "Java Development",
    title: "Java Development",
    image: jd,
    overview:
      "Learn to build robust, scalable, and enterprise-grade applications using Java. This course covers Java fundamentals, object-oriented programming, collections, exception handling, JDBC, Spring Boot, REST APIs, databases, and deployment. Through practical projects, you'll gain hands-on experience developing real-world Java applications.",

    syllabus: [
      {
        title: "Module 1: Java Fundamentals",
        topics: [
          "Introduction to Java",
          "JDK, JRE & JVM",
          "Environmental Setup",
          "First Program",
          "Variables, Data Types & Operators",
          "User Input",
          "Control Statements",
          "Built in Classes",
        ],
      },
      {
        title: "Module 2: Object-Oriented Programming",
        topics: [
          "Introduction to OOPs",
          "Classes & Objects",
          "Class Attributes",
          "Class Methods",
          "Variable Scope",
          "Constructor",
          "Access Modifiers",
          "Aggregations",
          "Inheritance",
          "Polymorphism",
          "Overriding",
          "Static & Dynamic Binding",
          "Encapsulation & Abstraction",
          "Interfaces",
          "Packages",
          "Wrapper Classes",
          "Enums",
        ],
      },
      {
        title: "Module 3: Concepts of Java",
        topics: [
          "Collections Framework",
          "Exception Handling",
          "Multithreading",
          "File Handling",
          "Java Synchronization",
          "Java Networking",
          "Java Data Structures",
        ],
      },
      {
        title: "Module 4: Database Connectivity",
        topics: [
          "JDBC Fundamentals",
          "CRUD Operations",
          "MySQL Integration",
          "Prepared Statements",
        ],
      },
      {
        title: "Module 5: Advanced Java",
        topics: [
          "Command-Line Arguments",
          "Lambda Expressions",
          "Sending Email",
          "Applet Basics",
          "Javadoc Comments",
          "Autoboxing and Unboxing",
          "File Mismatch Method",
          "REPL (JShell )",
          "Multi-Release Jar Files",
          "Private Interface Methods",
          "Inner Class Diamond Operator",
          "Multiresolution Image API",
          "Collection Factory Methods",
          "Module System",
          "Nashorn javascript",
          "Method Reference",
          "Functional Interface",
          "Default Methods",
          "base64 encode Decode",
          "Switch Expressions",
          "Textblocks",
          "Dynamic CDS archive",
          "Z Garbage Collector",
          "Packaging Tools",
          "Record Classes",
          "Hidden Classes",
          "Patten Matching",
          "Garbage Collection",
          "JIT Compiler",
        ],
      },
      {
        title: "Module 6: Database Development (with NoSQL)",
        topics: [
          "Introduction to MongoDB",
          "Differnce between MongoDB and SQL",
          "MongoDB Compass",
          "MongoDB Installation",
          "MongoDB Shell",
          "CRUD Operation",
          "Datatypes in MongoDB",
          "Documents in MongoDB",
          "MongoDB Operators",
          "Aggregates in MongoDB Query",
          "MongoDB Atlas",
          "Mongo Projects",
        ],
      },
      {
        title: "Module 7: Database Development (with MySQL)",
        topics: [
          "Introduction to SQL",
          "Data Types in SQL",
          "Operators of SQL",
          "Database",
          "Table",
          "Query",
          "Views",
          "Clauses",
          "Joins",
          "SQL Keys",
          "SQL Indexes",
          "Advanced SQL",
          "Projects",
        ],
      },
      {
        title: "Module 8: Project Planning",
        topics: ["Projects on SQL", "Interview Preparation of SQL"],
      },
    ],
  },

  {
    id: "Python Programming",
    title: "Python Programming",
    image: py,
    overview:
      "Master one of the world's most versatile programming languages. This course covers Python fundamentals, data structures, object-oriented programming, file handling, APIs, automation, and popular libraries. You'll gain practical experience building applications, automating tasks, and solving real-world programming challenges.",

    syllabus: [
      {
        title: "Module 1: Python Fundamentals",
        topics: [
          "Introduction to Python",
          "Variables & Data Types",
          "Operators & Expressions",
          "Indentation & Comment in Python",
          "Input & Output",
        ],
      },
      {
        title: "Module 2: Control Flow",
        topics: [
          "Conditional Statements",
          "Loops",
          "break, continue, pass Statements",
        ],
      },
      {
        title: "Module 3: Data Structures",
        topics: ["String", "Lists", "Tuples", "Sets", "Dictionaries"],
      },
      {
        title: "Module 4: Function",
        topics: [
          "Syntax of Function",
          "Types of Functions",
          "Arguments",
          "Recursion Function",
          "Recursive Function",
          "Lambda functions",
          "Modules in python",
          "Packages",
        ],
      },
      {
        title: "Module 5: Object-Oriented Programming",
        topics: [
          "Classes & Objects",
          "Inheritance",
          "Polymorphism",
          "Iterators",
          "Encapsulation",
          "Exception Handling",
        ],
      },
      {
        title: "Module 6: File Handling & Modules",
        topics: [
          "Reading & Writing Files",
          "Modules & Packages",
          "Regular Expressions",
          "Logging",
        ],
      },
      {
        title: "Module 7: Python Matplotlib",
        topics: [
          "Introduction to Matplotlib",
          "Matplotlib pyplot",
          "Matplotlib Markers",
          "Matplotlib Line",
          "Matplotlib Labels",
          "Matplotlib Grid",
          "Matplotlib Subplot",
          "Matplotlib Scatter",
          "Matplotlib Bars",
          "Matplotlib Histogram",
          "Matplotlib Pie Charts",
        ],
      },
      {
        title: "Module 8: Seaborn & plotly",
        topics: [
          "Introduction to Seaborn visualization",
          "Countplot",
          "Boxplot",
          "Violinplot",
          "Pairplot",
          "Heatmap",
          "Scatterplot",
          "Plotting Geospatial maps using Plotly",
        ],
      },
      {
        title: "Module 9: Python MySQL & Python MongoDB",
        topics: [
          "MySQL Get Started",
          "MongoDB Get Started",
          "Create Database",
          "Create Table",
          "Insert, Select, Where, Order by",
          "Drop Table, Update, Delete",
          "Joins & Limit",
        ],
      },
      {
        title: "Module 10: Machine Learning (Basics)",
        topics: [
          "Getting Started",
          "Mean Median Mode",
          "Standard Deviation",
          "Percentile",
          "Data Distribution",
          "Normal data Distribution",
          "Scatter Plot",
          "Linear Regression",
          "Polynomial Regression",
          "Multiple Regression",
          "Scale",
          "Train/Test",
          "Decision Tree",
          "Confusion Matrix",
          "Hierarchical Clustering",
          "Logistic Regression",
          "Grid Search",
          "Categorical Data",
          "K-Means",
          "Bootstrap Aggregation",
          "Cross Validation",
          "AUC - ROC Curve",
          "K-nearest neighbors",
        ],
      },
      {
        title: "Module 11: Tkinter in Python",
        topics: [
          "Introduction to Tkinter",
          "First GUI application in Tkinter",
          "Tkinter Frame Widget",
          "Tkinter Labels",
          "Tkinter Buttons",
          "Tkinter Entry",
          "Tkinter CheckBox and CheckButtons",
          "Tkinter ListBox",
          "Tkinter MessageBox",
          "Geometry Management of Tkinter",
          "Binding Functions",
          "Working with connection of Tkinter",
        ],
      },
      {
        title: "Module 12: Numpy Introduction",
        topics: ["NumPy Introduction", "Applications of NumPy"],
      },
      {
        title: "Module 13: Pandas Introduction",
        topics: ["Introduction to Pandas", "Application of Pandas"],
      },
      {
        title: "Module 14: Project Planning",
        topics: [
          "Static Terminal Projects",
          "Projects like Billing System",
          "Project like ATM",
          "Projects like handling Pharmacy Management",
          "Software",
        ],
      },
      {
        title: "Module 15: Database Development (with NoSQL)",
        topics: [
          "Introduction to MongoDB",
          "Differnce between MongoDB and SQL",
          "MongoDB Compass",
          "MongoDB Installation",
          "MongoDB Shell",
          "CRUD Operation",
          "Datatypes in MongoDB",
          "Documents in MongoDB",
          "MongoDB Operators",
          "Aggregates in MongoDB Query",
          "MongoDB Atlas",
          "Mongo Projects",
        ],
      },
      {
        title: "Module 16: Database Development (with MySQL)",
        topics: [
          "Introduction to SQL",
          "Data Types in SQL",
          "Operators of SQL",
          "Database",
          "Table",
          "Query",
          "Views",
          "Clauses",
          "Joins",
          "SQL Keys",
          "SQL Indexes",
          "Advanced SQL",
          "Projects",
        ],
      },
    ],
  },

  {
    id: "Data Science",
    title: "Data Science",
    image: ds,
    overview:
      "Transform data into actionable insights using industry-standard tools and techniques. This course covers data analysis, visualization, statistics, machine learning, SQL, and predictive modeling using Python. Through real-world datasets and projects, you'll develop the skills needed to analyze data, build models, and support data-driven decision-making.",

    syllabus: [
      {
        title: "Module 1: Python Fundamentals",
        topics: [
          "Introduction to Python",
          "Variables & Data Types",
          "Operators & Expressions",
          "Indentation & Comment in Python",
          "Input & Output",
        ],
      },
      {
        title: "Module 2: Control Flow",
        topics: [
          "Conditional Statements",
          "Loops",
          "break, continue, pass Statements",
        ],
      },
      {
        title: "Module 3: Data Structures",
        topics: ["String", "Lists", "Tuples", "Sets", "Dictionaries"],
      },
      {
        title: "Module 4: Function",
        topics: [
          "Syntax of Function",
          "Types of Functions",
          "Arguments",
          "Recursion Function",
          "Recursive Function",
          "Lambda functions",
          "Modules in python",
          "Packages",
        ],
      },
      {
        title: "Module 5: Object-Oriented Programming",
        topics: [
          "Classes & Objects",
          "Inheritance",
          "Polymorphism",
          "Iterators",
          "Encapsulation",
          "Exception Handling",
        ],
      },
       {
        title: "Module 6: File Handling & Modules",
        topics: [
          "Reading & Writing Files",
          "Modules & Packages",
          "Regular Expressions",
          "Logging",
        ],
      },
      {
        title: "Module 7: Introduction to Data Science",
        topics: [
          "Overview of AI, ML & Ds",
          "Understanding the various applications of Data Science",
          "Different sectors using Data Science",
        ],
      },
      {
        title: "Module 8: Database Development (with NoSQL)",
        topics: [
          "Introduction to MongoDB",
          "Differnce between MongoDB and SQL",
          "MongoDB Compass",
          "MongoDB Installation",
          "MongoDB Shell",
          "CRUD Operation",
          "Datatypes in MongoDB",
          "Documents in MongoDB",
          "MongoDB Operators",
          "Aggregates in MongoDB Query",
          "MongoDB Atlas",
          "Mongo Projects",
        ],
      },
      {
        title: "Module 9: Database Development (with MySQL)",
        topics: [
          "Introduction to SQL",
          "Data Types in SQL",
          "Operators of SQL",
          "Database",
          "Table",
          "Query",
          "Views",
          "Clauses",
          "Joins",
          "SQL Keys",
          "SQL Indexes",
          "Advanced SQL",
          "Projects",
        ],
      },
      {
        title: "Module 10: Advanced Excel",
        topics: [
        "Introduction to excel",
        "Explore Window",
        "Create Worksheet",
        "Copy Worksheet",
        "Hiding Worksheet",
        "Delete Worksheet",
        "Close Workbook",
        "Open Workbook",
        "Merge Workbook",
        "File Password",
        "File Share",
        "Emojis and Symbols",
        "Insert data",
        "Select data",
        "Rows and Columns",
        "Find and Replace",
        "Spell Check",
        "Zoom in-out",
        "Special Symbols",
        "Insert Comments",
        "Add Text Box",
        "Shapes 3D Models",
        "Checkbox",
        "Add Sketch",
        "Word Art",
        "Formatting Cells",
        "Formatting Worksheets",
        "Basic Formula",
        "Excel Formatting",
        "Advanced Options",
        ],
      },
      {
        title: "Module 11: Power BI",
        topics: [
          "Power BI",
          "Power BI Desktop",
          "Power BI Services",
          "Power BI Desktop Services",
          "Power Query Editor",
          "Data Modelling Concept",
          "Power BI - Report Visualizations",
          "Power BI Map Visualizations",
          "Power BI Miscellaneous",
          "Power BI Dashboard",
          "Power BI Sales Production Dashboard",
        ],
      },
      {
        title: "Module 12: Advanced Python",
        topics: [
          "Statistics",
          "Python Matplotlib",
          "Seaborn & plotly",
          "Pandas",
          "NumPy"
        ],
      },
      {
        title: "Module 13: Machine Learning",
        topics: [
          "Introduction to Machine Learning",
          "Data Visualization",
          "Statistics for ML",
          "Regression Analysis",
          "Classification Algorithm",
          "Clustering Algorithms",
          "Modal Optimization",
          "Projects on ML",
        ],
      },
      {
        title: "Module 14: Artificial Intelligence",
        topics: [
          "Introduction to AI",
          "PCA",
          "Boosting Algorithm",
          "Natural Language Processing",
          "Image Processing using OpenCV",
          "Deep Learning AI & Neutral Network",
          "TensorFlow",
          "Activation & Loss Functions & Optimizer",
          "ANN",
          "CNN",
          "Deep Learning Project",
          "Project on AI",
        ],
      },
    ],
  },

  {
    id: "DevOps",
    title: "DevOps",
    image: dev,
    overview:
      "Learn the tools and practices that streamline software development and deployment. This course covers Linux, Git, CI/CD pipelines, Docker, Kubernetes, cloud platforms, infrastructure automation, monitoring, and DevOps best practices. You'll gain hands-on experience building automated deployment workflows and managing modern cloud-native applications.",

    syllabus: [
      {
        title: "Module 1: DevOps Fundamentals",
        topics: [
          "Introduction to DevOps",
          "Software Development Lifecycle",
          "DevOps Culture",
          "Agile Methodology",
        ],
      },
      {
        title: "Module 2: Linux & Git",
        topics: [
          "Linux Commands",
          "Shell Scripting",
          "Git Basics",
          "GitHub Workflows",
        ],
      },
      {
        title: "Module 3: CI/CD",
        topics: [
          "Jenkins Fundamentals",
          "Build Automation",
          "Pipeline Creation",
          "Continuous Delivery",
        ],
      },
      {
        title: "Module 4: Containerization",
        topics: [
          "Docker Basics",
          "Docker Images",
          "Docker Compose",
          "Container Management",
        ],
      },
      {
        title: "Module 5: Kubernetes",
        topics: [
          "Kubernetes Architecture",
          "Pods & Deployments",
          "Services & Ingress",
          "Scaling Applications",
        ],
      },
      {
        title: "Module 6: Cloud & Infrastructure",
        topics: [
          "AWS Fundamentals",
          "Infrastructure as Code",
          "Terraform Basics",
          "Cloud Deployments",
        ],
      },
      {
        title: "Module 7: Monitoring & Security",
        topics: ["Prometheus", "Grafana", "Logging", "DevSecOps Basics"],
      },
      {
        title: "Module 8: Project Planning",
        topics: [
          "CI/CD Pipeline Setup",
          "Container Deployment",
          "Cloud Hosting",
          "Monitoring Implementation",
        ],
      },
    ],
  },

  {
    id: "Salesforce",
    title: "Salesforce",
    image: sf,
    overview:
      "Become proficient in the world's leading customer relationship management (CRM) platform. This course covers Salesforce administration, data management, automation, security, reporting, dashboards, and basic development concepts. Through practical exercises, you'll learn how to customize and optimize Salesforce solutions for business needs.",

    syllabus: [
      {
        title: "Module 1: Salesforce Fundamentals",
        topics: [
          "Introduction to Salesforce",
          "CRM Concepts",
          "Salesforce Navigation",
          "Data Model Basics",
        ],
      },
      {
        title: "Module 2: Data Management",
        topics: [
          "Objects & Fields",
          "Relationships",
          "Data Import Wizard",
          "Data Loader",
        ],
      },
      {
        title: "Module 3: Security & Access",
        topics: [
          "Profiles & Roles",
          "Permission Sets",
          "Sharing Rules",
          "Field-Level Security",
        ],
      },
      {
        title: "Module 4: Automation",
        topics: [
          "Workflow Rules",
          "Process Builder",
          "Flows",
          "Approval Processes",
        ],
      },
      {
        title: "Module 5: Reports & Dashboards",
        topics: [
          "Custom Reports",
          "Dashboard Creation",
          "Report Filters",
          "Analytics Basics",
        ],
      },
      {
        title: "Module 6: Apex & Development",
        topics: ["Apex Programming", "Triggers", "SOQL & SOSL", "Unit Testing"],
      },
      {
        title: "Module 7: Lightning Experience",
        topics: [
          "Lightning Components",
          "App Builder",
          "Page Customization",
          "Deployment",
        ],
      },
      {
        title: "Module 8: Project Planning",
        topics: [
          "Business Process Automation",
          "CRM Customization",
          "Reporting Solution",
          "Project Deployment",
        ],
      },
    ],
  },

  {
    id: "SAP",
    title: "SAP",
    image: sap,
    overview:
      "Gain a strong foundation in enterprise resource planning (ERP) using SAP. This course introduces core business processes, SAP navigation, financial management, materials management, sales and distribution, analytics, and SAP S/4HANA concepts. You'll learn how organizations use SAP to streamline operations and improve business efficiency.",

    syllabus: [
      {
        title: "Module 1: SAP Fundamentals",
        topics: [
          "Introduction to SAP",
          "ERP Concepts",
          "SAP Architecture",
          "SAP Navigation",
        ],
      },
      {
        title: "Module 2: Business Processes",
        topics: [
          "Procure-to-Pay",
          "Order-to-Cash",
          "Record-to-Report",
          "Business Process Integration",
        ],
      },
      {
        title: "Module 3: SAP Financials",
        topics: [
          "General Ledger",
          "Accounts Payable",
          "Accounts Receivable",
          "Financial Reporting",
        ],
      },
      {
        title: "Module 4: SAP Materials Management",
        topics: [
          "Procurement",
          "Inventory Management",
          "Vendor Management",
          "Purchasing Process",
        ],
      },
      {
        title: "Module 5: SAP Sales & Distribution",
        topics: [
          "Sales Processes",
          "Customer Management",
          "Pricing",
          "Order Processing",
        ],
      },
      {
        title: "Module 6: SAP Analytics",
        topics: [
          "SAP Reports",
          "SAP Queries",
          "Data Analysis",
          "Business Intelligence Basics",
        ],
      },
      {
        title: "Module 7: SAP S/4HANA",
        topics: [
          "Introduction to S/4HANA",
          "Fiori Applications",
          "Migration Concepts",
          "Digital Transformation",
        ],
      },
      {
        title: "Module 8: Project Planning",
        topics: [
          "Business Process Configuration",
          "ERP Workflow Implementation",
          "Reporting & Analysis",
          "Project Presentation",
        ],
      },
    ],
  },
];

export default courses;